import axios from 'axios';

//TODO: Move errors to separate file and add to Singularity
export class Errors {
  /**
   * Create a new Errors instance.
   */
  constructor() {
    this.errors = {};
  }

  /**
   * Determine if an errors exists for the given field.
   *
   * @param {string} field
   */
  has(field) {
    return this.errors.hasOwnProperty(field);
  }

  /**
   * Determine if we have any errors.
   */
  any() {
    return Object.keys(this.errors).length > 0;
  }

  /**
   * Retrieve the error message for a field.
   *
   * @param {string} field
   */
  get(field) {
    if (this.errors[field]) {
      return this.errors[field][0];
    }
  }

  /**
   * Record the new errors.
   *
   * @param {object} errors
   */
  record(errors) {
    this.errors = errors.errors;
    if(!this.errors){
      this.errors = [];
    }
  }

  /**
   * Clear one or all error fields.
   *
   * @param {string|null} field
   */
  clear(field = null) {
    if (field) {
      delete this.errors[field];

      return;
    }

    this.errors = {};
  }
}

class TForm {
  /**
   * Create a new Form instance.
   *
   * @param {object} data
   * @param reset
   */
  constructor(data, reset) {
    this.doReset = true;
    if (reset !== undefined) {
      this.doReset = reset;
    }

    this.originalData = data;

    for (const field in data) {
      this[field] = data[field];
    }

    this.errors = new Errors();
  }

  /**
   * Fetch all relevant data for the form.
   */
  data() {
    let data = new FormData;
    let json = {};

    for (const property in this.originalData) {
      if (this[property] instanceof File) {
        data.append(property, this[property]);
        continue;
      }
      json[property] = this[property];
    }
    data.append('json-form-data', JSON.stringify(json));

    return data
  }

  /**
   * Reset the form fields.
   */
  reset() {
    for (const field in this.originalData) {
      this[field] = this.originalData[field];
    }

    this.errors.clear();
  }

  /**
   * Send a POST request to the given URL.
   * .
   * @param {string} url
   * @param config
   */
  post(url, config = {}) {
    return this.submit('post', url, config);
  }

  /**
   * Send a PUT request to the given URL.
   * .
   * @param {string} url
   * @param config
   */
  put(url, config = {}) {
    return this.submit('put', url, config);
  }

  /**
   * Send a PATCH request to the given URL.
   * .
   * @param {string} url
   * @param config
   */
  patch(url, config = {}) {
    return this.submit('patch', url, config);
  }

  /**
   * Send a DELETE request to the given URL.
   * .
   * @param {string} url
   * @param config
   */
  delete(url, config = {}) {
    return this.submit('delete', url, config);
  }

  /**
   * Submit the form.
   *
   * @param {string} requestType
   * @param {string} url
   * @param data
   * @param config
   */
  submit(requestType, url, config = {}, data = this.data()) {
    return new Promise((resolve, reject) => {
      let instance = this.createAxiosInstance(requestType, url, data, config);
      instance.then(response => {
        this.onSuccess(response.data);
        resolve(response.data);
      }).catch(error => {
        this.onFail(error.response.data);
        reject(error.response.data);
      });
    });
  }

  createAxiosInstance(requestType, url, data, config = {}) {
    const types = ['post', 'put', 'patch'];
    if (types.indexOf(requestType) !== -1) {
      if (requestType === 'put') {
        data.append('_method', 'PUT');
      }
      if (requestType === 'patch') {
        data.append('_method', 'PATCH');
      }
      return axios['post'](url, data, config);
    }

    return axios[requestType](url, config);
  }

  /**
   * Handle a successful form submission.
   *
   * @param {object} data
   */
  onSuccess(data) {
    // for (const field in this.originalData) {
    //   this[field] = this.originalData[field];
    // }
    if (this.doReset) {
      this.reset();
    }
  }

  /**
   * Handle a failed form submission.
   *
   * @param {object} errors
   */
  onFail(errors) {
    this.errors.record(errors);
  }

  // TODO: implement dirty method
  // dirty() {
  //   for (const field in this.originalData) {
  //     return this[field] !== this.originalData[field];
  //   }
  // }
}

export default TForm;
